
import wxBridge from '../jsbridge/jsbridge_base.js';
import env from '../common/env.js';

wxBridge.addDownloadTask = wxBridge.addDownloadTask || function(param, callback) {
    var clientversion = env.clientVersion(true);
	
    // begin log
    if ( window.logInfo ) {
        logInfo('addDownloadTask begin', param)
    }

    /*
    *	@desc 强制要求给jsapi传task_size
    */
    if( undefined === param.task_size){
        alert('Need task_size');
        return;
    }
    /*
    *	@desc 强制要求给jsapi传 alternative_url
    *   用于做出错校验下载的。
    */
    if( undefined === param.alternative_url){
        alert('Need alternative_url');
        return;
    }

    /*
    *	@desc 因为开平又搞事。要换jsapi名字。由addDownloadTask 改成 
    *   addDownloadTaskStraight。
    *   @caution addDownloadTaskStraight只在6.5.6以上 版本下使用。
    */
	if (env.versionCompare(clientversion, '6.5.7') >= 0) {
        wxBridge.invoke('addDownloadTaskStraight', param, function(res) {
            
            // begin log
            if ( window.logInfo ) {
                logInfo('addDownloadTask ret', res)
            }

            callback(res)
        });
    }else{
        wxBridge.invoke('addDownloadTask', param, function(res) {

            // begin log
            if ( window.logInfo ) {
                logInfo('addDownloadTask ret', res)
            }

            callback(res)
        });
    }
    
};

export default wxBridge;

export const {
    addDownloadTask
} = wxBridge;
